import { CustomToastrAction, toastr } from "@/imports-files/common/common";
import { REDIRECT } from "@/imports-files/pages/clients/jobs/job";
import { CandidateListAction } from "@/services/components/candidate-listing-action";
import { AddCandidate } from "@/services/pages/candidates/add-candidate";
import {onCancelClick, setAutomationHash, manageAutomationTimer} from "@/imports-files/pages/candidates/add-candidate";
import { OtherSourceService } from "@/services/common/other-source";


export class OtherSourceAction
{
   constructor( setValue, setSuggestion)
    {
        this.setValue                  =   setValue;
        this.setSuggestion             =   setSuggestion;
        this.customToastrAction        =   new CustomToastrAction();
        this.otherSourceService        =   new OtherSourceService();
   }

  escapeRegexCharacters(str)
  {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async getSuggestions({value})
  {
    const escapedValue = this.escapeRegexCharacters(value?.trim());
    if (escapedValue === '')
    {
       return [];
    }
    const userList = await this.otherSourceService.getOtherSourceName();
    return userList.data.other_source_users;
  }

  getSuggestionValue(suggestion)
  {
      return suggestion
  }

  renderSuggestion(suggestion)
  {
      return <div> {suggestion}</div>
  }

  onSuggestionsFetchRequested = async (value) => {
    var suggestion = await this.getSuggestions(value);
    this.setSuggestion(suggestion);
  }

  onSuggestionsClearRequested = () => { this.setSuggestion([])};

  shouldRenderSuggestions(value)
  {
    return value?.trim().length >= 3
  }
}